import axios from 'axios';

export default {
  getAddressLine1(address){
    if(address.street==null || address.street==''){
      return null
    }
    return address.street;
  },
  getAddressLine2(address){
    var line = "";
    if(address.city!=null){
      line+=address.city;
    }
    if(address.postal_code!=null && address.postal_code!=''){
      if(line!=''){
        line+=", " + address.postal_code;
      }else{ line = address.postal_code}
    }
    if(line==""){return null}
    return line;

  },
  getAddressLine3(address){
    var line="";
    if(address.state!=null){
      line+=address.state.name;
    }else if(address.other_state!=null && address.other_state!=""){
      line+=address.other_state;
    }
    if(line==""){line=address.country.name}else{line+=", "+address.country.name}
    return line;
  }
}
